import { httpClient } from "@bw/shared/api";
import type { ActivityFeedItem } from "@bw/shared/types/generated";

export interface DashboardStats {
  total_organizations: number;
  total_facilities: number;
  total_users: number;
  total_revenue: number;
  pending_approvals: number;
  open_reports: number;
}

export async function getDashboardStats(): Promise<DashboardStats> {
  return httpClient.get<DashboardStats>("/platform/dashboard/stats");
}

/**
 * Curated platform activity feed — the dedicated `/platform/activity-feed`
 * endpoint filters the audit log to platform-relevant events (org approvals,
 * moderation, admin sessions, contract publishes), unlike the raw `/audit`
 * log which includes every action. Ordered by created_at desc.
 */
export async function getActivityFeed(limit = 20): Promise<ActivityFeedItem[]> {
  return httpClient.get<ActivityFeedItem[]>(
    `/platform/activity-feed?limit=${limit}`,
  );
}
